import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*

/** Public view of a configurable content_page (spec 10.4). Fetches by slug and renders its HTML. */
@Composable
fun ContentPageScreen(slug: String) {
    var page by remember(slug) { mutableStateOf<ContentPageDto?>(null) }
    var loading by remember(slug) { mutableStateOf(true) }
    var error by remember(slug) { mutableStateOf<String?>(null) }

    LaunchedEffect(slug) {
        loading = true
        try {
            page = Api.fetchContentPage(null, slug)
            error = null
        } catch (e: Throwable) {
            error = "Načtení stránky selhalo: ${e.apiMessage()}"
        }
        loading = false
    }

    Div(attrs = { classes("card") }) {
        if (loading) Text("Načítám…")
        error?.let { Div { Text("Chyba: $it") } }
        val p = page
        if (p != null) {
            RichContent(p.bodyHtml)
        } else if (!loading && error == null) {
            Text("Stránka nenalezena.")
        }
    }
}
